/* eslint-disable consistent-return */
/**
 *
 * LinkDetailCard
 *
 */

import React from 'react';
import _get from 'lodash/get';
import { Dialog, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import RichTextReactRenderer from 'components/RichTextReactRenderer';
import useSiteCopySelector from 'components/useSiteCopySelector';
import LinkDetailPopup from 'components/LinkItemSmall/LinkDetailPopup';
import { useSelector } from 'react-redux';
import { makeSelectClientDetails } from 'containers/Main/selectors';
import { VisitSiteButton } from './VisitSiteButton';

const useStyles = makeStyles(theme => ({
  contentWrapper: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    padding: 30,
    borderRadius: 8,
    zIndex: 10,
    backgroundColor: '#fff',
    overflowY: props => props.inModal && 'auto',
  },
  paper: {
    maxWidth: '900px',
    width: '100%',
    borderRadius: '8px !important',
  },
  button: {
    width: 152,
    marginTop: theme.spacing(2),
  },
  closeButton: {
    padding: 6,
    margin: '0px 0px 8px auto',
  },
  contentContainer: {
    display: 'flex',
    gap: 16,
    flexWrap: 'wrap',
    overflowY: props => props.inModal && 'auto',

    '& > div:first-child': {
      flexBasis: 'calc(60% - 8px)',
      flexGrow: 1,
      minWidth: 'min(100%, 400px)',
    },
    '& > div:last-child': {
      flexBasis: 'calc(40% - 8px)',
      flexGrow: 1,
    },
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 4,
    marginBottom: theme.spacing(3),
  },
}));

function LinkDetailCard({
  item,
  onClose,
  onClick,
  previewMode,
  inModal = true,
}) {
  const classes = useStyles({ inModal });
  const [siteCopy] = useSiteCopySelector(['resource-item-page']);
  const clientDetails = useSelector(makeSelectClientDetails());
  const customNextTitle = clientDetails?.metadata?.nextStepsTitle;
  const cardTitle = item.title || item.name;
  const nextTitle =
    (previewMode ? _get(item, 'nextStepsTitle') : customNextTitle) ||
    _get(siteCopy, 'pageCopy.hybridLinkNextSteps');

  const content = (
    <div className={classes.contentWrapper}>
      <div className={classes.headerContainer}>
        <Typography id="title" variant="h4" color="textPrimary">
          {cardTitle}
        </Typography>
        <IconButton
          className={classes.closeButton}
          aria-label="Close"
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </div>
      <div className={classes.contentContainer} tabIndex={-1}>
        {item.readMoreInfo && (
          <div>
            <RichTextReactRenderer
              className={classes.body}
              data={item.readMoreInfo}
            />
          </div>
        )}
        {item.nextSteps && (
          <div>
            <Typography variant="h5" color="primary">
              {nextTitle}
            </Typography>
            <RichTextReactRenderer
              className={classes.body}
              data={item.nextSteps}
            />
          </div>
        )}
      </div>
      <VisitSiteButton
        title={cardTitle}
        className={classes.button}
        siteCopy={siteCopy}
        onClick={onClick}
      />
    </div>
  );

  if (inModal) {
    return (
      <Dialog
        classes={{ paper: classes.paper }}
        open
        onClose={onClose}
        aria-labelledby="title"
      >
        {content}
      </Dialog>
    );
  }

  return <LinkDetailPopup onClose={onClose}>{content}</LinkDetailPopup>;
}

export default LinkDetailCard;
